export default __webpack_public_path__ + "static/media/image7.e0283c9a.jpg";